module.exports = __webpack_public_path__ + "img/PG.8f89e1fa.svg";